'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var es = require('./es');
var en = require('./en');

var resources = exports.resources = {
  en: en,
  es: es
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/index.js
// module id = 690
// module chunks = 0